import { render } from "./calc_tariff.vue?vue&type=template&id=652947a0&scoped=true"
import script from "./calc_tariff.vue?vue&type=script&lang=js"
export * from "./calc_tariff.vue?vue&type=script&lang=js"

import "./calc_tariff.vue?vue&type=style&index=0&id=652947a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652947a0"]])

export default __exports__